export const shareIconsSrcMap = {
  shareEmail: { name: "ShareEmail.svg" },
  shareWhatsapp: { name: "ShareWhatsapp.svg" },
  shareFacebook: { name: "ShareFacebook.svg" },
  shareTwitter: { name: "ShareTwitter.svg" },
  sharePinterest: { name: "SharePinterest.svg" }
}

export type shareIconsName = keyof typeof shareIconsSrcMap
